import React from 'react';
import C from '../../constants/colors';

export default function RolePill({ role }) {
  const color = role === 'SUPER_ADMIN' ? C.purple : role === 'ADMIN' ? C.blue : C.amber;
  return (
    <span style={{
      fontSize: '10px', fontWeight: 700, padding: '2px 7px', borderRadius: '20px',
      background: color + '22', color, border: `1px solid ${color}44`, whiteSpace: 'nowrap',
    }}>
      {role === 'SUPER_ADMIN' ? 'SUPER ADMIN' : role}
    </span>
  );
}
